import { Box, Typography } from "@mui/material";

const getStatusColor = (status: string) => {
  switch (status) {
    case "2":
      return "#8ECB14";
    case "3":
      return "#F0C300";
    case "4":
      return "#FF3B3B";
    case "5":
      return "#C4C4C4";
    case "6":
      return "#1E90FF";
    default:
      return "transparent";
  }
};

export const getStatusLabel = (status: string) => {
  switch (status) {
    case "2":
      return "Verde";
    case "3":
      return "Amarelo";
    case "4":
      return "Vermelho";
    case "5":
      return "Cinza";
    case "6":
      return "Vistoria";
    default:
      return "Ñ param.";
  }
};

interface ChannelStatusProps {
  status: string;
  isLabel?: boolean;
}

const ChannelStatusMenu: React.FC<ChannelStatusProps> = ({
  status,
  isLabel = true,
}) => {
  const color = getStatusColor(status);
  const label = getStatusLabel(status);

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Box
        sx={{
          width: 14,
          height: 14,
          minWidth: 14,
          minHeight: 14,
          borderRadius: "50%",
          backgroundColor: color,
          border: "1px solid #818181",
        }}
      />
      {isLabel && <Typography variant="body2">{label}</Typography>}
    </Box>
  );
};

export default ChannelStatusMenu;
